// @flow

import React, { Component } from 'react';

import { formatFullDate, getDateFromString } from 'utils/dateUtils';
import CompetitionsInternationalesDefaultHeaderContainer from 'components/competitionsInternationales/CompetitionsInternationalesDefaultHeader';
import { STATUS_SUCCESS } from 'constants/statusConstants';
import type { CompetitionInternationale } from 'types/competitionsInternationales';
import type { RencontreType } from 'types/Rencontre';
import type { Status } from 'types/Status';
import { shouldUsePlaceholder } from 'utils/assetsUtils';

export type StateProps = {
  data: CompetitionInternationale,
  rencontre: RencontreType,
  status: Status
};

type State = {
  isFixed: boolean,
  offset: number
};

type OwnProps = {
  goBack(): void
};

type Props = StateProps & OwnProps;

// @TODO add link "En direct"
export default class CompetitionInternationalesMatchHeader extends Component<Props, State> {
  observer: IntersectionObserver | null = null;
  mutationObserver: MutationObserver | null = null;
  ref: HTMLDivElement | null = null;

  state = {
    isFixed: false,
    offset: 0
  };

  componentDidMount() {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    const {
      rencontre: {
        meta: { rencontre_live }
      },
      status
    } = this.props;
    if (status === STATUS_SUCCESS && rencontre_live && this.ref) {
      // $FlowFixMe
      this.observer = new IntersectionObserver(entries => {
        this.setState({ isFixed: !!entries[0] && entries[0].intersectionRatio === 0 });
      });

      this.observer.observe(this.ref);
    }

    const header = document.querySelector('header.header.header--over');
    if (header) {
      this.mutationObserver = new MutationObserver(([event]) => {
        if (event.type === 'attributes') {
          // $FlowFixMe
          this.setState({ offset: event.target.classList.contains('header--fixed') ? event.target.offsetHeight : 0 });
        }
      });
      this.mutationObserver.observe(header, {
        attributes: true,
        attributeFilter: ['class'],
        childList: false,
        characterData: false
      });
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    const {
      rencontre: {
        meta: { rencontre_live }
      },
      status
    } = this.props;
    if (status !== prevProps.status || rencontre_live !== prevProps.rencontre.meta.rencontre_live) {
      if (status === STATUS_SUCCESS && rencontre_live && this.ref) {
        // $FlowFixMe
        this.observer = new IntersectionObserver(entries => {
          this.setState({ isFixed: !!entries[0] && entries[0].intersectionRatio === 0 });
        });

        this.observer.observe(this.ref);
      } else if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  render() {
    const {
      data,
      rencontre: {
        meta: {
          adversaire,
          rencontre_live,
          lieu,
          reception,
          adversaire_score,
          france_score,
          france_logo,
          adversaire_logo,
          adversaire_drapeau,
          france_drapeau,
          date_rencontre
        }
      },
      status,
      goBack
    } = this.props;
    const { isFixed, offset } = this.state;

    if (status !== STATUS_SUCCESS) {
      return null;
    }

    if (!rencontre_live) {
      return <CompetitionsInternationalesDefaultHeaderContainer data={data} goBack={goBack} />;
    }

    const dateRencontre = date_rencontre ? getDateFromString(date_rencontre) : null;

    return (
      <section className="banner live-match__banner">
        <div className={`live-match__teams-header${isFixed ? ' is-fixed' : ''}`} style={{ '--header-top': `${offset - 1}px` }}>
          <div className="live-match__teams-header__btn">
            <span className='btn btn-header-live'>EN DIRECT</span>
          </div>
          <div className="live-match__teams-header__score">
            <span className="">{reception ? 'France' : adversaire}</span>

            <div className="logo-container">
              <img
                src={shouldUsePlaceholder(
                  { embleme_adversaire: adversaire_drapeau||adversaire_logo, embleme_france: france_drapeau || france_logo, reception },
                  true
                )}
                alt={`Logo ${reception ? 'France' : adversaire}`}
                width="24"
                height="24"
              />
            </div>

            <span className="live-match__teams-header__score__result">
              <span className="">{reception ? france_score : adversaire_score}</span>
              <span className="">-</span> <span className="">{reception ? adversaire_score : france_score}</span>
            </span>

            <div className="logo-container">
              <img
                src={shouldUsePlaceholder(
                  { embleme_adversaire: adversaire_drapeau || adversaire_logo, embleme_france: france_drapeau || france_logo, reception },
                  false
                )}
                alt={`Logo ${!reception ? 'France' : adversaire}`}
                width="24"
                height="24"
              />
            </div>

            <span>{reception ? adversaire : 'France'}</span>
          </div>

          <div className="live-match__date">
            <span>
              {dateRencontre &&
                `${formatFullDate(dateRencontre)} à ${dateRencontre.getHours()}h${dateRencontre.getMinutes() >= 10 ? dateRencontre.getMinutes() : '0'+dateRencontre.getMinutes()}`}
              , <span className="live-match__date__place">{lieu}</span>
            </span>
          </div>
        </div>

        <div className="banner__thumbnail img-blue-dark" style={{ backgroundImage: 'url(/img/banner/xv.jpg)' }} />

        <div className="banner__content">
          <div className="banner__content__return">
            <button onClick={goBack} className="go-back">
              <i className="icon icon-chevron-left is-inline" />
              <span>{'Retour'}</span>
            </button>
          </div>

          <div className="banner__content__title" ref={ref => (this.ref = ref)}>
            <p><span className="btn btn-banner">EN DIRECT</span></p>
            <h1 className="live-match__teams ft-up">
              <span>
                <span className="">{reception ? 'France' : adversaire}</span>
                <img
                  src={shouldUsePlaceholder(
                    { embleme_adversaire: adversaire_drapeau||adversaire_logo, embleme_france: france_drapeau || france_logo, reception },
                    true
                  )}
                  alt={`Logo ${reception ? 'France' : adversaire}`}
                  width="40"
                  height="40"
                />
              </span>
              <span>
                <span className="live-match__teams__score">{reception ? france_score : adversaire_score}</span>
                <span className="live-match__teams__score">-</span>{' '}
                <span className="live-match__teams__score">{reception ? adversaire_score : france_score}</span>
              </span>
              <span>
              <img
                src={shouldUsePlaceholder(
                  { embleme_adversaire: adversaire_drapeau || adversaire_logo, embleme_france: france_drapeau || france_logo, reception },
                  false
                )}
                alt={`Logo ${!reception ? 'France' : adversaire}`}
                width="40"
                height="40"
              />
              <span>{reception ? adversaire : 'France'}</span>
              </span>
            </h1>

            <p className="live-match__date">
              {dateRencontre &&
                `${formatFullDate(dateRencontre)} à ${dateRencontre.getHours()}h${dateRencontre.getMinutes() >= 10 ? dateRencontre.getMinutes() : '0'+dateRencontre.getMinutes()}`}
            </p>

            <p className="live-match__place">{lieu}</p>
          </div>
        </div>
      </section>
    );
  }
}
